__webpack_require__.p = "https://anushkachauhxn.github.io/fm-rock-paper-scissors-lizard-spock/";